"use client";

import { Toaster } from "@workspace/ui/components/sonner";
import { BreadcrumbProvider } from "@workspace/ui/hooks/breadcrumb-context";
import { Session } from "next-auth";
import { SessionProvider } from "next-auth/react";
import { ThemeProvider as NextThemesProvider } from "next-themes";
import * as React from "react";
import { PostHogProvider } from "./PostHogProvider";

export function Providers({
  postHogApiToken,
  cspNonce,
  children,
  session,
}: {
  session?: Session | null;
  cspNonce?: string;
  postHogApiToken?: string;
  children: React.ReactNode;
}) {
  return (
    <PostHogProvider apiToken={postHogApiToken!} cspNonce={cspNonce!}>
      <SessionProvider session={session}>
        <NextThemesProvider
          attribute="class"
          defaultTheme="system"
          enableSystem={true}
          disableTransitionOnChange={true}
          enableColorScheme={true}
          nonce={cspNonce}
        >
          <BreadcrumbProvider>
            {children}
            <Toaster />
          </BreadcrumbProvider>
        </NextThemesProvider>
      </SessionProvider>
    </PostHogProvider>
  );
}
